import { Currency, IItemVariant, Money } from '@rediredi/types'
import { CartItem } from '~/types/cart'
import { IStorefrontItem } from '~/types/item'

export const toCartItem = (
  item: IStorefrontItem,
  quantity: number,
  variant: IItemVariant,
  currency?: Currency,
): CartItem => {
  const unleashClient = getUnleashClient()

  const pictures =
    item.options?.length && variant.pictures?.length ? variant.pictures : item.pictures
  let price: Money = {
    ...item.baseVariant.price!,
    currency: currency || item.baseVariant.price?.currency || Currency.BRL,
  }
  let promotionPrice = item.baseVariant.promotionPrice
    ? {
        ...item.baseVariant.promotionPrice,
        currency: currency || item.baseVariant.promotionPrice?.currency || Currency.BRL,
      }
    : undefined

  const isVariationPriceEnabled = unleashClient.isEnabled('storefront.variation-price')
  if (isVariationPriceEnabled) {
    promotionPrice = variant?.promotionPrice
    price = variant.price as Money
  }

  return {
    id: item.id,
    pictures: pictures || [],
    title: item.baseVariant.title as string,
    quantity,
    quantityAvailable: variant.quantityAvailable ?? 1,
    price,
    promotionPrice,
    promotion: item.promotion,
    variantId: variant.id || item.id,
    optionMapping: variant.optionMapping,
  }
}

export const itemTotal = (item: CartItem, currency?: Currency) => {
  const amount = item.price?.amount ?? 0
  const quantity = item.quantity
  return formatPriceInParts(amount * quantity, {
    currency: currency || item.price?.currency || Currency.BRL,
  })
}
